import { SerializedInventoryMeter } from '@enmon/commons/lib/tools';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { Nullable } from '@enmon/commons';
import { useEnmonMeters } from './api/enmon-tools/meters/useFind';
import { useInventoryMeter } from './api/inventory-meter/useFindOne';

interface ContextMeterShape {
  enmonMeter: Nullable<SerializedMeter>;
  inventoryMeter: Nullable<SerializedInventoryMeter>;
  isLoading: boolean;
}

export const useContextMeter = (inventoryMeterId: SerializedInventoryMeter['id']): ContextMeterShape => {
  const { data: enmonMeterData, isFetching: isLoadingEnmonMeter } = useEnmonMeters(
    { toolsIds: [inventoryMeterId.toString()] },
    { enabled: !!inventoryMeterId },
  );
  const { data: inventoryMeterData, isFetching: isLoadingInventoryMeter } = useInventoryMeter(inventoryMeterId, {
    enabled: !!inventoryMeterId,
  });

  const enmonMeter = enmonMeterData?.result && enmonMeterData.result.length === 1 ? enmonMeterData.result[0] : null;
  const inventoryMeter = inventoryMeterData ?? null;

  return { enmonMeter, inventoryMeter, isLoading: isLoadingEnmonMeter || isLoadingInventoryMeter };
};
